(() => {
  function initialize(scope) {
    scope.querySelectorAll('.tt-de-robots__track').forEach(track => {
      if (track.dataset.ttHoverReady) return;
      track.dataset.ttHoverReady = 'true';
      const desktop = matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
      const cards = [...track.querySelectorAll('[data-tt-robot]')];
      let active;
      const align = () => {
        if (!desktop.matches || !active || track.classList.contains('tt-de-is-dragging')) return;
        const bounds = track.getBoundingClientRect();
        const cardBounds = active.getBoundingClientRect();
        const contentBounds = track.closest('.tt-de-robots__inner').getBoundingClientRect();
        const adjustment = cardBounds.right > contentBounds.right ? cardBounds.right - contentBounds.right : cardBounds.left < contentBounds.left ? cardBounds.left - contentBounds.left : 0;
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        if (Math.abs(adjustment) > 1) track.scrollTo({ left: Math.max(0, Math.min(maximum, track.scrollLeft + adjustment)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      cards.forEach(card => card.addEventListener('pointerenter', () => {
        if (!desktop.matches || track.classList.contains('tt-de-is-dragging')) return;
        active = card;
        track.classList.add('tt-de-robots__track--hover-active');
        cards.forEach(item => item.classList.toggle('tt-de-robot--hover-active', item === card));
        requestAnimationFrame(align);
      }));
      track.addEventListener('transitionend', event => { if (event.propertyName === 'flex-basis') align(); });
      desktop.addEventListener('change', () => {
        if (!desktop.matches) {
          active = null;
          track.classList.remove('tt-de-robots__track--hover-active');
          cards.forEach(card => card.classList.remove('tt-de-robot--hover-active'));
        }
      });
    });
    scope.querySelectorAll('[data-tt-robot]').forEach(card => {
      if (card.dataset.ttReady) return;
      card.dataset.ttReady = 'true';
      const tabs = [...card.querySelectorAll('[data-tt-tab]')];
      const prev = card.querySelector('[data-tt-prev]');
      const next = card.querySelector('[data-tt-next]');
      const featureList = () => [...card.querySelectorAll('.tt-de-robot__features ul')].find(list => getComputedStyle(list).display !== 'none');
      function select(index, focus = false, animate = false) {
        card.querySelectorAll('[data-tt-panel]').forEach(panel => {
          panel.hidden = Number(panel.dataset.ttPanel) !== index;
          panel.classList.remove('is-entering');
          if (!panel.hidden && animate && !matchMedia('(prefers-reduced-motion: reduce)').matches) panel.classList.add('is-entering');
        });
        card.classList.toggle('tt-de-robot--features', index === 1);
        tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
        if (index === 1) {
          const list = featureList();
          card.classList.toggle('tt-de-robot--expanded', matchMedia('(max-width: 749px)').matches && list.scrollHeight > 252);
        } else card.classList.remove('tt-de-robot--expanded');
        prev.disabled = index === 0;
        next.disabled = index === 1;
        if (focus) tabs[index].focus();
      }
      prev.addEventListener('click', () => select(0, false, true));
      next.addEventListener('click', () => select(1, false, true));
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(i));
        tab.addEventListener('keydown', event => {
          if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
            event.preventDefault();
            select(event.key === 'ArrowLeft' || event.key === 'Home' ? 0 : 1, true);
          }
        });
      });
      let touchStart;
      const panels = card.querySelector('.tt-de-robot__panels');
      panels.addEventListener('touchstart', e => { touchStart = e.changedTouches[0].clientX; }, { passive: true });
      panels.addEventListener('touchend', e => {
        const delta = e.changedTouches[0].clientX - touchStart;
        if (Math.abs(delta) > 50) select(delta < 0 ? 1 : 0);
      }, { passive: true });
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(() => {
          const featurePanel = card.querySelector('[data-tt-panel="1"]');
          if (!featurePanel.hidden) card.classList.toggle('tt-de-robot--expanded', matchMedia('(max-width: 749px)').matches && featureList().scrollHeight > 252);
        });
        card.querySelectorAll('.tt-de-robot__features ul').forEach(list => observer.observe(list));
      }
    });
    scope.querySelectorAll('.tt-de-robots__track, .tt-de .pongbot26-61-three-steps__track, .tt-de .pongbot26-61-video-reviews__track, .tt-de .pongbot26-61-testimonials__track').forEach(track => {
      if (track.dataset.ttReady) return;
      track.dataset.ttReady = 'true';
      const dots = [...track.closest('section').querySelectorAll('[data-tt-step], [data-tt-page]')];
      if (track.children.length < 2) return;
      const section = track.closest('section');
      const prev = section.querySelector('[data-pongbot26-61vr-prev], [data-pongbot26-61ts-prev]');
      const next = section.querySelector('[data-pongbot26-61vr-next], [data-pongbot26-61ts-next]');
      const positions = () => [...track.children].map(child => Math.min(Math.max(0, track.scrollWidth - track.clientWidth), child.offsetLeft - track.children[0].offsetLeft));
      let active = 0;
      const show = index => {
        const stops = positions();
        active = Math.max(0, Math.min(index, stops.length - 1));
        track.scrollTo({ left: stops[active], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      const update = () => {
        const stops = positions();
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        active = track.scrollLeft >= max - 1 && max > 0 ? stops.length - 1 : stops.reduce((best, stop, i) => Math.abs(stop - track.scrollLeft) < Math.abs(stops[best] - track.scrollLeft) ? i : best, 0);
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === active)));
        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft >= max - 1;
      };
      dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
      if (prev) prev.addEventListener('click', () => {
        const stops = positions();
        const target = stops.reduce((last, stop, index) => stop < track.scrollLeft - 1 ? index : last, -1);
        show(Math.max(0, target));
      });
      if (next) next.addEventListener('click', () => {
        const stops = positions();
        const target = stops.findIndex(stop => stop > track.scrollLeft + 1);
        show(target < 0 ? stops.length - 1 : target);
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      let origin;
      let moved = false;
      track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button') || track.scrollWidth <= track.clientWidth) return;
        origin = { x: event.clientX, left: track.scrollLeft, id: event.pointerId };
        moved = false;
      });
      track.addEventListener('pointermove', event => {
        if (!origin) return;
        const delta = event.clientX - origin.x;
        if (Math.abs(delta) > 5) {
          moved = true;
          track.setPointerCapture(origin.id);
          track.classList.add('tt-de-is-dragging');
          track.scrollLeft = origin.left - delta;
          event.preventDefault();
        }
      });
      const finishDrag = () => { if (!origin) return; origin = null; track.classList.remove('tt-de-is-dragging'); update(); if (moved) show(active); };
      track.addEventListener('pointerup', finishDrag);
      track.addEventListener('pointercancel', finishDrag);
      track.addEventListener('lostpointercapture', finishDrag);
      track.addEventListener('click', event => { if (moved) { event.preventDefault(); event.stopPropagation(); moved = false; } }, true);
      track.addEventListener('dragstart', event => event.preventDefault());
      update();
    });
    scope.querySelectorAll('.tt-de .pongbot26-61-why-train__scenes').forEach(track => {
      if (track.dataset.ttDesignReady) return;
      track.dataset.ttDesignReady = 'true';
      const cards = [...track.children];
      const desktop = matchMedia('(min-width: 750px) and (hover: hover)');
      let active = 0;
      const alignActive = () => {
        const card = cards[active];
        const edge = parseFloat(getComputedStyle(track).paddingLeft) || 0;
        const width = track.closest('section').querySelector('.pongbot26-61-why-train__inner').clientWidth;
        track.scrollTo({ left: Math.max(0, card.offsetLeft + 570 - edge - width), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        track.dispatchEvent(new Event('scroll'));
      };
      const activate = index => {
        active = Math.max(0, Math.min(cards.length - 1, index));
        const card = cards[active];
        cards.forEach(item => item.toggleAttribute('data-tt-active-scene', item === card));
        requestAnimationFrame(alignActive);
      };
      track.addEventListener('transitionend', event => { if (desktop.matches && event.propertyName === 'flex-basis') alignActive(); });
      cards[0]?.setAttribute('data-tt-active-scene', 'true');
      cards.forEach(card => card.addEventListener('pointerenter', () => {
        if (!desktop.matches || track.classList.contains('is-dragging')) return;
        activate(cards.indexOf(card));
      }));
      let sceneDrag;
      track.addEventListener('pointerdown', event => { if (desktop.matches && event.button === 0) sceneDrag = { x: event.clientX, index: active }; }, true);
      track.addEventListener('pointerup', event => {
        if (!sceneDrag) return;
        const delta = event.clientX - sceneDrag.x;
        if (Math.abs(delta) > 50) activate(sceneDrag.index + (delta < 0 ? 1 : -1));
        sceneDrag = null;
      }, true);
      track.addEventListener('pointercancel', () => { sceneDrag = null; }, true);
      const progress = track.closest('section').querySelector('[data-pongbot26-61wt-progress-track]');
      let progressDrag = false;
      const chooseFromPointer = event => {
        const bounds = progress.getBoundingClientRect();
        const ratio = Math.max(0, Math.min(1, (event.clientX - bounds.left) / bounds.width));
        activate(Math.round(ratio * (cards.length - 1)));
      };
      progress.addEventListener('pointerdown', event => {
        if (!desktop.matches || event.button !== 0) return;
        event.preventDefault(); event.stopImmediatePropagation(); progressDrag = true;
        progress.setPointerCapture(event.pointerId); chooseFromPointer(event);
      }, true);
      progress.addEventListener('pointermove', event => { if (progressDrag) { event.stopImmediatePropagation(); chooseFromPointer(event); } }, true);
      progress.addEventListener('pointerup', () => { progressDrag = false; }, true);
      progress.addEventListener('pointercancel', () => { progressDrag = false; }, true);
      progress.addEventListener('keydown', event => {
        if (!desktop.matches || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault(); event.stopImmediatePropagation();
        activate(event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1));
      }, true);
    });
    scope.querySelectorAll('.tt-de .pongbot26-61-faq__item').forEach(details => {
      if (details.dataset.ttReady) return;
      details.dataset.ttReady = 'true';
      const summary = details.querySelector('summary');
      const answer = details.querySelector('.pongbot26-61-faq__answer-wrap');
      let animation;
      let expanded = details.open;
      summary.addEventListener('click', event => {
        if (matchMedia('(prefers-reduced-motion: reduce)').matches || !answer.animate) return;
        event.preventDefault();
        const from = details.open ? answer.getBoundingClientRect().height : 0;
        if (animation) animation.cancel();
        expanded = !expanded;
        details.open = true;
        const to = expanded ? answer.scrollHeight : 0;
        animation = answer.animate([{ height: `${from}px`, opacity: from ? 1 : 0 }, { height: `${to}px`, opacity: expanded ? 1 : 0 }], { duration: 300, easing: 'ease-out' });
        answer.style.overflow = 'hidden';
        animation.onfinish = () => { details.open = expanded; answer.style.overflow = ''; animation = null; };
      });
    });
  }
  if (!window.pongbotTTDesignLoaded) {
    window.pongbotTTDesignLoaded = true;
    document.addEventListener('shopify:section:load', event => initialize(event.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
    else initialize(document);
  }
})();
